(function(window, $) {
  var $document = $(window.document);

    $document.on("ready", function() {

        function sendErrorData() {
            let errorContainer = $('.woocommerce-error');
            if (errorContainer.length) {
                let errorMessages = errorContainer.children().map(function() { return $(this).text().trim() }).get().join();
                
                let analytics = {
                    page_category_L1: "Become a Member",
                    page_category_L2: "Checkout",
                    error_message: errorMessages
                }

                CSAnalytics("Error Displayed", analytics)
            }
        }
        
        // triggered when there is an error on checkout form
        $document.on('checkout_error', sendErrorData)

        // triggered when a stripe error occurs
        $document.on('stripeError', sendErrorData)

        // Handles login errors
        if (window.loginErrors) {
            let analytics = {
                page_category_L1: "Login",
                page_category_L2: null,
                error_message: window.loginErrors.text
            }

            CSAnalytics("Error Displayed", analytics)
        }

        // Element displayed when a gform validation error occurs
        const gFormError = $('.gform_validation_errors');

        if (gFormError.length) {
            const errors = $('.gform_validation_error_link');
            
            let errorMessages = [];

            if (errors.length) {                
                let analytics = {};

                errors.each(function() {
                    errorMessages.push($(this).text())
                })

                analytics.error_messages = errorMessages;

                if (window.articleAnalytics) {
                    analytics.page_category_L1 = window.articleAnalytics.content_title;
                } else {
                    analytics.page_category_L1 = null;
                }

                analytics.page_category_L2 = null;

                // gravity form ids are in the format 'gform_<id>'
                const formIdArray = $('.gform_wrapper form').attr('id').split('_');
                const formId = parseInt(formIdArray[formIdArray.length - 1]);
                
                if(formId) {
                    analytics.form_id = formId;
                } else {
                    analytics.form_id = null;
                }


                CSAnalytics("Error Displayed", analytics)
            }
        }
    })
})(window, jQuery);
